/* global axios */
import ApiClient from './ApiClient';

class MotorReservaCalendarAPI extends ApiClient {
  constructor() {
    super('motor_reserva_calendar', { accountScoped: true });
  }

  grid(startDate, days = 20) {
    return axios.get(`${this.url}/grid`, {
      params: { start_date: startDate, days },
    });
  }

  updatePrices(payload) {
    return axios.post(`${this.url}/update_prices`, payload);
  }

  updateRestrictions(payload) {
    return axios.post(`${this.url}/update_restrictions`, payload);
  }

  updateInventory(payload) {
    return axios.post(`${this.url}/update_inventory`, payload);
  }
}

export default new MotorReservaCalendarAPI();
